<template>
	<div class="settingDiv my-2 mx-auto p-1 overflow-auto bg-white shadow border w-80">
		<div class="d-flex justify-content-between">
			<h3>Profile Settings</h3>
			<!-- <b-button :disabled="!dirty" variant="outline" class="text-primary" @click.prevent="save">
				<span v-if="dirty">save</span>
			</b-button> -->
		</div>
		<div class="border-top mx-3">
			<div class="showNumberEmail">
				<div class="d-flex justify-content-center">
					<span>HiringCenter Phone Number: {{$parseNumber(user.Twilio)}}</span>
				</div>
				<div v-if="user.SendGrid" class="d-flex justify-content-center">
					<span>HiringCenter Email: {{user.SendGrid}}</span>
				</div>
			</div>

			<b-form>
				<b-form-group label-cols="2" label="First Name:">
					<b-form-input
						v-model="form.First"
						@change="saveDataOnChange()"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Last Name:">
					<b-form-input
						v-model="form.Last"
						@change="saveDataOnChange()"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Title:">
					<b-form-input
						v-model="form.Title"
						@change="saveDataOnChange()"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Email:">
					<b-form-input
						type="email"
						v-model="form.Email"
						@change="saveDataOnChange()"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Phone number:">
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="numberMask"
						@change="onNumberChange()"
						@keydown="onNumberKeyDown($event)"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Allow Notifications:">
					<b-form-checkbox 
						v-model="form.Notification" 
						name="check-button" switch
						@change="updateNotificationSetting($event)" style="padding-top:10px">
						<!-- Automated Apply Text -->
					</b-form-checkbox>
				</b-form-group>
				
				<b-form-group label-cols="2" label="Client Contact:">
					<b-form-input
						v-model="form.Contact"
						@change="saveDataOnChange()"
						required />
				</b-form-group>

				<b-form-group class="custom-outbox" label-cols="2" label="Primary Location:">
					<!-- <b-form-group label-cols="2" label="Street Address:"> -->
						<div class="row">
							<div class="col-6">
								<b-form-group>
									<b-form-input
										v-model="form.PrimaryLocation.StreetAddress"
										placeholder="Street Address:"
										class=""
										@change="saveDataOnChange()"
										required />
									</b-form-group>
							</div>
							<div class="col-6">
								<b-form-group>
									<b-form-input
										v-model="form.PrimaryLocation.City"
										placeholder="City"
										@change="saveDataOnChange()"
										required />
								</b-form-group>
							</div>
						
						
						<!-- <b-form-input
							v-model="form.Contact4"
							placeholder="State"
							required /> -->

						<!-- <b-dropdown text="00">
				
							<b-dropdown-item :key="st" v-for="st in stateList">{{st}}</b-dropdown-item>
						</b-dropdown> -->
						<div class="col-2">
							<b-form-group>
								<b-form-select 
									v-model="form.PrimaryLocation.State" 
									:options="stateList" 
									class="custom-coutry-dropdown"
									@change="stateChange"
								>
								</b-form-select>
							</b-form-group>
						</div>
						<div class="col-10">
							<b-form-group>
								<b-form-input class="custom-imput-box"
									v-model="form.PrimaryLocation.ZipCode"
									placeholder="Postal Code"
									type="text"
									@change="saveDataOnChange()"
									@keydown="isCheckPostalCode($event)"
									required />
								</b-form-group>
							</div>
						</div>
					<!-- </b-form-group> -->
				</b-form-group>
			</b-form>
		</div>
		<h3>Call and Email Settings</h3>
		<div class="border-top mx-3">
			<!-- <b-form> -->
				<!--<b-form-group
					label-cols="2"
					label="Automatic Text Response"
					description="If on, taTEXT will automatically send this message to candidates who send messages to your taTEXT number.">
						<b-form-checkbox
							v-model="autoResponseEnabled"
							switch/>
						<b-form-textarea
							v-if="autoResponseEnabled"
							rows="2"
							max-rows="6"
							required />
				</b-form-group>-->
				<b-form-group
					label-cols="2"
					label="Call Forwarding"
					class="pt-3"
					description=""
				>
					<!--<b-form-checkbox
						v-model="callForwardEnabled"
						switch />-->
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="forwardMask"
						@change="fmOnChange()"
						@keydown="fmOnKeyDown($event)"
					/>
				</b-form-group>

				<b-form-group
					label-cols="2"
					label="Text Forwarding"
					class="pt-3"
					description=""
				>
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="form.ForwardText"
						@change="fmOnChange()"
						@keydown="fmOnKeyDown($event)"
					/>
				</b-form-group>

				<b-form-group
					label-cols="2"
					label="Email Forwarding"
					class="pt-3"
					description=""
				>
					<!--<b-form-checkbox
						v-model="callForwardEnabled"
						switch />-->
					<b-form-input
						type="email"
						placeholder="example@domain.com"
						v-model="form.ForwardEmail"
						@change="saveDataOnChange()"
					/>
				</b-form-group>

				<b-form-group 
                    label-cols="2" 
                    label="Email Signature:" 
                    class="my-2 send-editor"
                >
                    <vue-editor 
						v-model="form.EmailSignature"
                        :v-on:change="updateEmailSignature()"
                    ></vue-editor>
                </b-form-group>

				<!-- <b-form-group v-if="!forwardMask"
					label-cols="2"
					label="Voicemail"
					class="pt-3 setrow"
				>
				
					<b-button variant="primary" class="p-2 mr-3" @click="openRecordModal" >Record</b-button>
					<audio v-if="user.VoicemailRecord" :src="user.VoicemailRecord" controls />
					<div v-if="user.VoicemailRecord">
						<button @click="removeVoiceMail" class="button is-dark">
							<v-icon name="trash" />
						</button>
					</div>
				</b-form-group> -->
			<!-- </b-form> -->
		</div>
		<h3>Organization Settings</h3>
		<div class="border-top mx-3 mb-3">
			<b-form>
				<b-form-group
					label-cols="2"
					label="Pipeline Stages (Statuses):"
					class="w-100 pt-3"
				>
					<draggable v-model="form.Stages" class="d-inline">
						<div  style="float:left"
							:key="index"
							v-for="(stage, index) in form.Stages"
							class="stagesTagUI border rounded bg-white d-inline-block"
						>
							<span class="button-text pl-1" style="padding-right:6px;">{{stage}}</span>
							<b-button v-if="hideSomeDeleteStageOption(index)" variant="outline" class="stagesTagUIClose border-0 no-glow" 
							@click="deleteStage(index)">
								<v-icon class="text-blue" name="times" />
							</b-button>
						</div>
					</draggable>
					<b-button style="float:left" v-if="!showStageInput" variant="outline" class="border" @click="showStageInput = true">
						<v-icon name="plus" class="text-blue" />
					</b-button>
					<!-- <b-input-group v-if="showStageInput" prepend="Stage" class="mt-3"> -->
						<!-- <b-form-input
							v-focus
							v-model="newStage"
							style="width: 10em"
							class="d-inline-block"
							v-if="showStageInput"
							@keydown.enter="createStage"
						/>
						<b-input-group-append v-if="showStageInput">
							<b-button variant="outline-success">
						<v-icon name="check" class="text-blue" />
								
							</b-button> -->
						<b-input-group v-if="showStageInput" style="width: 30%;float: left;">
							<template v-slot:append>
								<b-input-group-text style="cursor: pointer;">
									<strong class="text-danger" @click="createStage">
										<v-icon name="check" class="text-blue" />
									</strong>
								</b-input-group-text>
							</template>
							<b-form-input v-model="newStage"></b-form-input>
						</b-input-group>
					<!-- </b-input-group-append> -->
					<!-- </b-input-group> -->

						
				</b-form-group>
			
			</b-form>
			<b-form>
				<b-form-group
					label-cols="2"
					label="Prospect Folders (Tags):"
					class="w-100 pt-3"
				>
					<draggable v-model="form.Forms" class="d-inline">
						<div style="float:left"
							:key="index"
							v-for="(folder, index) in form.Folders"
							class="stagesTagUI border rounded bg-white d-inline-block"
						>
							<span class="button-text pl-1">{{folder}}</span>
							<b-button variant="outline" class="stagesTagUIClose border-0 no-glow" @click="deleteFolder(index)">
								<v-icon class="text-blue" name="times" />
							</b-button>
						</div>
					</draggable>
					<b-button style="float:left" v-if="!showFolderInput" variant="outline" class="border" @click="showFolderInput = true">
						<v-icon name="plus" class="text-blue" />
					</b-button>
					<!-- <b-form-input
						v-focus
						style="width: 10em"
						v-model="newFolder"
						v-if="showFolderInput"
						class="d-inline-block"
						@keydown.enter="createFolder"
					/> -->
					<b-input-group v-if="showFolderInput" style="width: 30%;float: left;">
						<template v-slot:append>
							<b-input-group-text style="cursor: pointer;">
								<strong class="text-danger" @click="createFolder">
									<v-icon name="check" class="text-blue" />
								</strong>
							</b-input-group-text>
						</template>
						<b-form-input v-model="newFolder"></b-form-input>
					</b-input-group>
				</b-form-group>
			</b-form>

			<b-form>
				<b-form-group
					label-cols="2"
					label="Task Templates:"
					class="w-100 pt-3"
				>
					<draggable v-model="form.Tasks" class="d-inline">
						<div style="float:left"
							:key="index"
							v-for="(task, index) in form.Tasks"
							class="stagesTagUI border rounded bg-white d-inline-block"
						>
							<span class="button-text pl-1">{{task}}</span>
							<b-button variant="outline" class="stagesTagUIClose border-0 no-glow" @click="deleteTask(index)">
								<v-icon class="text-blue" name="times" />
							</b-button>
						</div>
					</draggable>
					<b-button style="float:left" v-if="!showTaskInput" variant="outline" class="border" @click="showTaskInput = true">
						<v-icon name="plus" class="text-blue" />
					</b-button>
					<b-input-group v-if="showTaskInput" style="width: 30%;float: left;">
						<template v-slot:append>
							<b-input-group-text style="cursor: pointer;">
								<strong class="text-danger" @click="createTask">
									<v-icon name="check" class="text-blue" />
								</strong>
							</b-input-group-text>
						</template>
						<b-form-input v-model="newTask"></b-form-input>
					</b-input-group>
				</b-form-group>
			</b-form>


		</div>
		

		<h3>Automation Settings</h3>
		<div class="border-top mx-3 automation">
			<!-- <b-form> -->
				<b-form-checkbox 
					v-model="form.AutoOffice" 
					name="check-button" switch
					@change="updateAutomatedOffice($event)" style="padding-top:10px">
					Auto Assign Closest Office
				</b-form-checkbox>
				<b-form-checkbox 
					v-model="form.ApplyText" 
					name="check-button" switch
					@change="updateAutomatedApply($event)" style="padding-top:10px">
					Automated Apply Text
				</b-form-checkbox>
				<b-form-checkbox label-cols="2"
					v-model="form.AutoText" 
					name="check-button" switch
					@change="updateAutomatedFollowUp($event)" style="padding-top:10px">
					Automated Follow-Up Text
				</b-form-checkbox>
				<div class="automation-inputbox" style="padding-top:15px">

					<!-- <div class="chip-container">
						<div class="chip">{{getChips}}</div>
						<input v-model="form.ExploringText" @keypress.enter="saveChip" @keydown.delete="backspaceDelete">
					</div> -->

					<!-- <div class="custom-tag1">
						<span >{{form.ExploringText}}</span>
						<div contentEditable="true" class="custom-tag">himani</div>
						<span >abcdef</span>
					</div> -->
					
					<b-form-group label-cols="2" label="Exploring Follow-Up:" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left:645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue" style="z-index: 1;">
								<b-dropdown-item  @click="addTagToExploring('[firstName]')">Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToExploring('[licensingLink]')">licensingLink</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea class="exploring"
							v-model="form.ExploringText"
							@change="saveDataOnChange()"
							required style="width:635px"/>
					</b-form-group>

					<b-form-group label-cols="2" label="In-Process Follow-Up:" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left: 645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue">
								<b-dropdown-item  @click="addTagToProcess('[firstName]')">Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToProcess('[licensingLink]')">licensingLink</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea
							v-model="form.InProcessText"
							@change="saveDataOnChange()"
							required style="width:635px"/>
					</b-form-group>

					<b-form-group label-cols="2" label="Licensed Follow-Up:" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left: 645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue" >
								<b-dropdown-item  @click="addTagToLicensed('[firstName]')">Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToLicensed('[licensingLink]')">licensingLink</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea
							v-model="form.LicensedText"
							@change="saveDataOnChange()"
							required  style="width:635px"/>
					</b-form-group>
				</div>

				<!--
				<b-form-checkbox label-cols="2"
					v-model="form.SendGroup" 
					name="check-button" switch
					@change="updateAutomatedGroupMessage($event)" style="padding-top:10px">
					Automated Group Message with Manager
				</b-form-checkbox>
				-->

				<div class="automation-inputbox" style="padding-top:15px">

					<b-form-group label-cols="2" label="Group Message Verbiage" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left: 645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue" >
								<b-dropdown-item  @click="addTagToGroupMsg('[ManagerName]')">Manager Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToGroupMsg('[ProspectFirstName]')">Prospect First Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToGroupMsg('[ProspectFullName]')">Prospect Full Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagToGroupMsg('[UserName]')">User Name (My Name)</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea
							v-model="form.GroupMessage"
							@change="saveDataOnChange()"
							required  style="width:635px"/>
					</b-form-group>
				</div>

				<!--
				<b-form-checkbox label-cols="2"
					v-model="form.AutoAppointmentSetting" 
					name="check-button" switch
					@change="updateAppointmentReminderSetting($event)" style="padding-top:10px">
					Automated Appointment Reminder
				</b-form-checkbox>

				<div class="automation-inputbox" style="padding-top:15px">

					<b-form-group label-cols="2" label="Automated 24h Appointment Reminder" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left: 645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue" >
								<b-dropdown-item  @click="addTagTo24HGroupMsgApp('{{ManagerName}}')">Manager Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo24HGroupMsgApp('{{ProspectFirstName}}')">Prospect First Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo24HGroupMsgApp('{{ProspectFullName}}')">Prospect Full Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo24HGroupMsgApp('{{UserName}}')">User Name (My Name)</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea
							v-model="form.AutoAppointment24h"
							@change="saveDataOnChange()"
							style="width:635px"/>
					</b-form-group>
				</div>

				<div class="automation-inputbox" style="padding-top:15px">

					<b-form-group label-cols="2" label="Automated 1h Appointment Reminder" style="position:relative;">
						<div class="select-wrapper" style="position: absolute;left: 645px;background: #ced4da;">
							<b-dropdown class="dropdown-wrapper" right variant="outline" toggle-class="text-blue" >
								<b-dropdown-item  @click="addTagTo1HGroupMsgApp('{{ManagerName}}')">Manager Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo1HGroupMsgApp('{{ProspectFirstName}}')">Prospect First Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo1HGroupMsgApp('{{ProspectFullName}}')">Prospect Full Name</b-dropdown-item>
								<b-dropdown-item  @click="addTagTo1HGroupMsgApp('{{UserName}}')">User Name (My Name)</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-form-textarea
							v-model="form.AutoAppointment1h"
							@change="saveDataOnChange()"
							style="width:635px"/>
					</b-form-group>
				</div>
				-->
				


			<!-- </b-form> -->
		</div>

		<h3>Message Settings</h3>
		<div class="border-top mx-3">
			<b-form>
				<b-form-group
					label-cols="3"
					label="Automatic Response"
					class="pt-3"	
				>
					<b-form-input
						placeholder="Set Automatic Response"
						v-model="form.AutoResponseMessage"
						@change="saveDataOnChange()"
					/>
					<b-form-checkbox 
						v-model="form.AutoResponseEnabled" 
						name="check-button" switch
						@change="updateResponse($event)">
						Automatic Response On/Off
					</b-form-checkbox>
				</b-form-group>
			</b-form>

			<!-- <b-form>
				<b-form-group
					label-cols="3"
					label="AI System Message"
					class="pt-3"	
				>
					<b-form-textarea
						placeholder="Set AI System Message"
						v-model="form.AiDescription"
						@change="saveDataOnChange()"
					/>
				</b-form-group>
			</b-form> -->

			<b-form>
				<b-form-group
					label-cols="3"
					label="Message Variables"
					class="pt-3"	
				>
				<div class="m-2 px-2 pt-2 bg-light border rounded ">
					<div class="d-flex mb-2 variable-wrapper">
						<b-form-input
							placeholder="Variable"
							v-model="varField"
							required
						/>
						<b-form-input
							placeholder="Value"
							v-model="varValue"
							required
						/>
						<div>
							<b-button variant="primary" class="p-2" @click="addVariable" >Save</b-button>
						</div>
					</div>
					<b-table-simple v-if="user.Variables" bordered striped responsive hover class="mx-auto text-left">
						<b-thead head-variant="light">
							<b-tr class="text-center">
								<b-th>Variable</b-th>
								<b-th>Value</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr
								:key="uv.field"
								class="text-left position-relative"
								v-for="uv of user.Variables"
								:class="{'pointer': uv.value.length > 50}"
							>
								<b-td>{{uv.field}}</b-td>
								<b-td class="pr-5 position-relative">
									{{uv.value}}
									<b-button
										style="right: 0"
										variant="outline"
										class="center-vert"
										@click="removeVar(uv)"
									>
										<v-icon class="text-blue" name="times" />
									</b-button>
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</div>
				</b-form-group>
			</b-form>
		</div>


		<!-- <h3 v-if="isResource">Resources</h3>
		<div v-if="isResource" class="border-top mx-3">
			<div class="row">
					<div :key="res.Title" v-for="res in user.Resources" class="text-center">
						<span style="max-width: 210px; word-break:break-all;display: inline-block;" class="m-0">{{res.Title}}</span><br>
						<iframe 
							class="embed-responsive-item" 
							:src="res.Src" 
							allowfullscreen
							height="210"
							width="210">
						</iframe>
					</div>
			</div>
		</div> -->
		<h3 >Resources</h3>
		<div  class="border-top mx-3 ">
			<b-button class="ResourcesTab bg-blue-btn mt-2 d-inline-block">
				<a target="blank" href="https://thirdpool.com/tatext/resources.html">Visit Resources Page</a>
			</b-button>
		</div>


		<b-modal id="VoiceMailModal" class="custon-video" title="Record Voicemail"  hide-footer @close="close" >
			<div> Press button once to record and a second time to stop. </div>
			<vue-record-audio mode="hold" @stream="onStream" @result="onResult" />
			<div class="column">
            <div class="recorded-audio">
				<div v-for="(record, index) in recordings" :key="index" class="recorded-item">
					<div class="audio-container"><audio :src="record.src" controls /></div>
					<div><button @click="removeRecord(index)" class="button is-dark">
					<v-icon name="trash" /></button></div>
				</div>
			</div>
		</div>
		<audio-recorder
			:attempts="1"
			:time="2"
			:after-recording="callback"/>
		<div class="call-bottom">
			<b-button variant="primary" class="p-2" @click="saveRecording" >Save 1</b-button>
			<b-button v-if="uploadValue > 0 && uploadValue < 100" variant="primary" class="p-2"  >Saving...</b-button>
			<b-button variant="primary" class="p-2" @click="saveRecording2" >Save 2</b-button>
		</div>
		</b-modal>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import { mapState } from 'vuex'
	import { VueEditor } from "vue2-editor";
	import { db,fbstore } from 'src/db'
	// import states from "public/states.json"
	import states from "../../../../public/states.json";

	export default {
		name: "Settings",
		components: {
			draggable,
			VueEditor,
		},
		created() {
			//eslint-disable-next-line
			console.log('user.Stages', this.user.Stages);
		},
		computed: {
			getChips() {
				//eslint-disable-next-line
				console.log(this.form.ExploringText.split(' '));
				// let ss = this.form.ExploringText.split(' ')
				// if (ss.indexOf('[firstName]')) {
					
				// }
				let chipstring = '';
				if (this.form.ExploringText.includes('[firstName]')) {
					let fi = this.form.ExploringText.indexOf("[firstName]")
					// let li = 
					// chipstring = fi;
					
					chipstring = this.form.ExploringText.substr(fi,fi+11);
					//eslint-disable-next-line
					console.log(chipstring);
					
				}
				
				// if (this.form.ExploringText.includes('[licensingLink]')) {
				// 	let li = this.form.ExploringText.indexOf("[licensingLink]")
				// 	chipstring = li;
				// }
				return chipstring;
			},
			stateList() {
				return states.States.map((item) => {
					return item.abbreviation;
				})
				// return []
			},
			minDate() {
				return new Date();
			},
			// dirtyFolders() {
			// 	if (!this.user.Folders) {
			// 		return this.form.Folders.length > 0;
			// 	} else if (this.form.Folders.length != this.user.Folders.length) {
			// 		return true;
			// 	}
			// 	for (let i = 0; i < this.user.Folders.length; i++) {
			// 		if (this.user.Folders[i] != this.form.Folders[i]) {
			// 			return true;
			// 		}
			// 	}
			// 	return false
			// },
			// dirtyStages() {
			// 	if (!this.user.Stages) {
			// 		return this.form.Stages.length > 0;
			// 	} else if (this.form.Stages.length != this.user.Stages.length) {
			// 		return true;
			// 	}
			// 	for (let i = 0; i < this.user.Stages.length; i++) {
			// 		if (this.user.Stages[i] != this.form.Stages[i]) {
			// 			return true;
			// 		}
			// 	}
			// 	return false
			// },
			// dirtyTasks() {
			// 	if (!this.user.Tasks) {
			// 		return this.form.Tasks.length > 0;
			// 	} else if (this.form.Tasks.length != this.user.Tasks.length) {
			// 		return true;
			// 	}
			// 	for (let i = 0; i < this.user.Tasks.length; i++) {
			// 		if (this.user.Tasks[i] != this.form.Tasks[i]) {
			// 			return true;
			// 		}
			// 	}
			// 	return false
			// },
			// dirty() {
			// 	return this.dirtyFolders || this.dirtyStages || this.dirtyTasks ||
			// 		this.user.First != this.form.First ||
			// 		this.user.Last != this.form.Last ||
			// 		this.user.Email != this.form.Email ||
			// 		// this.user.Number != this.form.Number ||
			// 		this.user.Number != this.$parseNumber(this.numberMask) ||
			// 		this.user.ForwardNumber != this.form.ForwardNumber ||
			// 		this.user.AutoResponseMessage != this.form.AutoResponseMessage ||
			// 		this.user.AutoResponseEnabled != this.form.AutoResponseEnabled 
			// 		// this.user.FromDate != this.form.FromDate ||
			// 		// this.user.ToDate != this.form.ToDate
			// },
			isResource() {
				let value = false;
				if (this.user && this.user.hasOwnProperty('Resources')) {
					value = true;
				}
				return value;
			},
			...mapState('firebase', ['user', 'prospects'])
		},
		methods: {
			// UPDATE EMAIL SIGNATURE
			updateEmailSignature() {
				if(this.user.EmailSignature != this.form.EmailSignature) {
					db.doc(`Users/${this.user.id}`).update({EmailSignature:this.form.EmailSignature});
				}
			},
			stateChange() {
				this.saveDataOnChange()
			},
			createFolder() {
				if(this.newFolder) {
					this.form.Folders.push(this.newFolder);
					this.showFolderInput = false;
					this.newFolder = "";
					this.save();
				}
			},
			createStage() {
				var convertCurrentStagesToUppercase = String(this.form.Stages).toUpperCase().split(","); // CONVERT ALL STAGES UPPER CASE
				var currentStageToUppercase = this.newStage.toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
				if(this.newStage) { // CHECK VALUE BLANK OR NOT
					var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
					if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false)
						this.form.Stages.push(this.newStage);
						this.showStageInput = false;
						this.newStage = "";
						this.save();
					}
				}
			},
			createTask() {
				if(this.newTask) {
					this.form.Tasks.push(this.newTask);
					this.showTaskInput = false;
					this.newTask = "";
					this.save();
				}
			},
			deleteFolder(index) {
				if (confirm(`Are you sure you would like to delete the folder '${this.form.Folders[index]}'?`)) {
					this.form.Folders.splice(index, 1);
				}
				this.save();
			},
			// HIDE DELETE OPTION SOME STAGES
			hideSomeDeleteStageOption(index) {
				if(this.user.Version && this.user.Version == 2) {
					if(this.form.Stages[index] == 'New' || this.form.Stages[index] == 'Contacted' || this.form.Stages[index] == 'Pre-Interview Nurture' || this.form.Stages[index] == 'Post-Interview Nurture' || this.form.Stages[index] == 'Offer' || this.form.Stages[index] == 'Hired' || this.form.Stages[index] == 'Lost to Competitors') {
						return 0;
					} else {
						return 1;
					}
				} else {
					return 1;
				}
			},
			stageRecursive(e2, currStageName) {
				var updatedForm;
				var getOnlyLastNameArray;
				var setNewStage = [{Date:new Date().valueOf(), Stage:"New"}];
				e2.Stages.splice(e2.Stages.indexOf(currStageName), 1); // REMOVE LAST ARRAY
				getOnlyLastNameArray = e2.Stages.slice(-1)[0]; // GET LAST ARRAY IN CURRENT TIME
				if(getOnlyLastNameArray) {
					var check = this.form.Stages.includes(getOnlyLastNameArray.Stage);
					if(!check) {
						this.stageRecursive(e2, currStageName);
					}
					if(e2.Stages.length == 0) {
						updatedForm = { Stages: setNewStage, Status:"New" }
					} else {
						getOnlyLastNameArray = e2.Stages.slice(-1)[0]; // GET LAST ARRAY IN CURRENT TIME
						updatedForm = { Stages: e2.Stages, Status:getOnlyLastNameArray.Stage }
					}
				} else {
					updatedForm = { Stages: setNewStage, Status:"New" }
				}
				db.doc(`Users/${this.user.id}/Prospects/${e2.id}`).update(updatedForm);
			},
			manageLastStage(index) {
				if(this.prospects && this.prospects.length > 0) {
					var currStageName = this.form.Stages[index];
					var gotPros = this.prospects.filter(e1 => e1.Status === currStageName);
					if(gotPros) {
						gotPros.forEach(e2 => {
							this.stageRecursive(e2, currStageName);
						});
					}
				}
			},
			deleteStage(index) {
				if (this.form.Stages[index] == 'Archived') {
					alert('You can no delete stage "Archived"')
					return;
				}
				if (confirm(`Are you sure you would like to delete the stage '${this.form.Stages[index]}'?`)) {
					this.manageLastStage(index);
					this.form.Stages.splice(index, 1);
				}
				this.save();
			},
			deleteTask(index) {
				if (confirm(`Are you sure you would like to delete the Task '${this.form.Tasks[index]}'?`)) {
					this.form.Tasks.splice(index, 1);
				}
				this.save();
			},
			save() {
				// if (!this.dirty) {
				// 	return;
				// }
				this.form.Number = this.$parseNumber(this.numberMask);
				this.form.ForwardNumber = this.$parseNumber(this.forwardMask);
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			fmOnKeyDown(event) {
				if (this.$parseNumber(this.forwardMask).length < 3) {
					if (event.key == '0' || event.key == '1') {
						event.preventDefault();
					}
				}
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			zipCodeOnKeyDown(event) {
				if (this.form.PrimaryLocation.ZipCode.length >= 5) {
					if (event.key == '0' || event.key == '1' || 
						event.key == '2' || event.key == '3' || 
						event.key == '4' || event.key == '5' || 
						event.key == '6' || event.key == '7' ||
						event.key == '8' || event.key == '9') 
					{
						event.preventDefault();
					}
				}
			},
			fmOnChange() {
				if (this.forwardMask && this.$parseNumber(this.forwardMask).length < 12) {
					alert("Call Forwarding Number is not valid");
					return
				}
				this.form.ForwardNumber = this.$parseNumber(this.forwardMask);
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			onNumberChange() {
				if (this.numberMask && this.$parseNumber(this.numberMask).length < 12) {
					alert("Phone Number is not valid");
					return
				}
				this.form.Number = this.$parseNumber(this.numberMask);
				db.doc(`Users/${this.user.id}`).update(this.form);	
			},
			onNumberKeyDown(event) {
				if (this.$parseNumber(this.numberMask).length < 3) {
					if (event.key == '0' || event.key == '1') {
						event.preventDefault();
					}
				}
			},
			saveDataOnChange() {
				this.form.Number = this.$parseNumber(this.numberMask);
				// this.form.ForwardNumber = this.$parseNumber(this.forwardMask);
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			updateResponse(event) {
				this.form.AutoResponseEnabled = event;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			updateAutomatedApply(event) {
				this.form.ApplyText = event;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			updateAutomatedOffice(event) {
				this.form.AutoOffice = event;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			updateAutomatedFollowUp(event) {
				if (event){
					if (this.form.ExploringText && this.form.InProcessText && this.form.LicensedText) {
						this.form.AutoText = event;
						db.doc(`Users/${this.user.id}`).update(this.form);
					}else {
						alert("Automated Follow-Up Text cannot be turned on with empty Follow-Up Messages.");
						setTimeout(() => {
							this.form.AutoText = false;	
						}, 0);
					}
				}else {
					this.form.AutoText = event;
					db.doc(`Users/${this.user.id}`).update(this.form);
				}
				
			},
			updateAutomatedGroupMessage(event) {
				this.form.SendGroup = event;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			// updateAppointmentReminderSetting(event) {
			// 	this.form.AutoAppointmentSetting = event;
			// 	db.doc(`Users/${this.user.id}`).update(this.form);
			// },
			updateNotificationSetting(event) {
				this.form.Notification = event;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			addVariable() {
				let isExist = false;
				let newAddedVar = [];
				if (this.user.Variables) {
					for (let vdata of this.user.Variables) {
						if (this.varField == vdata.field) {
							vdata.value = this.varValue;
							isExist = true;
						}
					}
					if (!isExist) {
						newAddedVar = this.user.Variables;
						newAddedVar.push({
							field:this.varField,
							value:this.varValue,
						});
					}else {
						newAddedVar = this.user.Variables;
					}
				}else {
					newAddedVar.push({
						field:this.varField,
						value:this.varValue,
					});
				}
				this.varField = '';
				this.varValue = '';
				db.doc(`Users/${this.user.id}`).update({ Variables: newAddedVar });
			},
			removeVar(uv) {
				if (confirm("Are you sure you want to delete this variable?")) {
					let i=0;
					for (let v of this.user.Variables) {
						if (uv.field == v.field) {
							this.user.Variables.splice(i,1)
						}
						i++;
					}
					db.doc(`Users/${this.user.id}`).update({ Variables: this.user.Variables });
				}
			},
			addTagToExploring(tag) {
				this.form.ExploringText = this.form.ExploringText +' ' + tag;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			addTagToProcess(tag) {
				this.form.InProcessText = this.form.InProcessText +' ' + tag;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			addTagToLicensed(tag) {
				this.form.LicensedText = this.form.LicensedText +' ' + tag;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			// addTagTo24HGroupMsgApp(tag) {
			// 	this.form.AutoAppointment24h = this.form.AutoAppointment24h +' ' + tag;
			// 	db.doc(`Users/${this.user.id}`).update(this.form);
			// },
			// addTagTo1HGroupMsgApp(tag) {
			// 	this.form.AutoAppointment1h = this.form.AutoAppointment1h +' ' + tag;
			// 	db.doc(`Users/${this.user.id}`).update(this.form);
			// },
			addTagToGroupMsg(tag) {
				this.form.GroupMessage = this.form.GroupMessage +' ' + tag;
				db.doc(`Users/${this.user.id}`).update(this.form);
			},
			saveChip() {
				const {chips, currentInput, set} = this;
				((set && chips.indexOf(currentInput) === -1) || !set) && chips.push(currentInput);
				this.currentInput = '';
			},
			// deleteChip(index) {
			// 	this.chips.splice(index, 1);
			// },
			backspaceDelete({which}) {
				which == 8 && this.currentInput === '' && this.chips.splice(this.chips.length - 1);
			},
			openRecordModal() {
				this.recordings = [];
				this.$bvModal.show('VoiceMailModal');
			},
			onStream (stream) {
				this.recordings = [];
				//eslint-disable-next-line
				console.log('Got a stream object:', stream);
				this.isRecording = true;
			},
			onResult (data) {
				this.recordings.push({
					src: window.URL.createObjectURL(data)
				})
				this.isRecording = false;
				//eslint-disable-next-line
				console.log(this.recordings);
				// const blob = new Blob(data, { 'type': 'audio/webm' });
				// this.sendAudioFile(blob);
			},
			
			removeRecord (index) {
				this.recordings.splice(index, 1)
			},
			saveRecording() {
				//eslint-disable-next-line
				console.log('1',this.recordings);
				if (this.recordings.length) {
					//eslint-disable-next-line
					console.log(this.recordings);
					this.getFileBlob(this.recordings[0].src, blob =>{
						// blob = blob.slice(0, blob.size, "audio/mpeg");
						const storageRef = fbstore.ref().child(this.user.id).put(blob);
						storageRef.on(`state_changed`,snapshot=>{
						this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
						}, error=>{
							//eslint-disable-next-line
							console.log(error.message)
						},
						()=>{this.uploadValue=100;
							storageRef.snapshot.ref.getDownloadURL().then((url)=>{
								this.uploadedMediaURL = url;
								db.doc(`Users/${this.user.id}`).update({'VoicemailRecord':this.uploadedMediaURL});
								// this.$bvModal.hide('VoiceMailModal');
							});
						});
					});
					
				}else {
					alert('Please first record something');
				}
			},
			saveRecording2() {
				//eslint-disable-next-line
				console.log('2',this.recordings);
				if (this.recordings.length) {
					//eslint-disable-next-line
					console.log(this.recordings);
					this.getFileBlob(this.recordings[1].url, blob =>{
						// blob = blob.slice(0, blob.size, "audio/mpeg");
						const storageRef = fbstore.ref().child(this.user.id+'22222222').put(blob);
						storageRef.on(`state_changed`,snapshot=>{
						this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
						}, error=>{
							//eslint-disable-next-line
							console.log(error.message)
						},
						()=>{this.uploadValue=100;
							storageRef.snapshot.ref.getDownloadURL().then((url)=>{
								this.uploadedMediaURL = url;
								db.doc(`Users/${this.user.id}`).update({'VoicemailRecord2':this.uploadedMediaURL});
								// this.$bvModal.hide('VoiceMailModal');
							});
						});
					});
					
				}else {
					alert('Please first record something');
				}
			},
			// sendAudioFile:function (file)  {
			// 	const formData = new FormData();
			// 	formData.append('audio-file', file);
			// 	// const storageRef = fbstore.ref().child(this.user.id).put(blob);
			// 	const storageRef = fbstore.ref(`${this.user.First}`).put(formData);
			// 	storageRef.on(`state_changed`,snapshot=>{
			// 	this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
			// 	}, error=>{
			// 		//eslint-disable-next-line
			// 		console.log(error.message)
			// 	},
			// 	()=>{this.uploadValue=100;
			// 		storageRef.snapshot.ref.getDownloadURL().then((url)=>{
			// 			this.uploadedMediaURL = url;
			// 			//eslint-disable-next-line
			// 			console.log(url);
			// 			// db.doc(`Users/${this.user.id}`).update({'VoicemailRecord':this.uploadedMediaURL});
			// 			// this.$bvModal.hide('VoiceMailModal');
			// 		});
			// 	});
			// },
			getFileBlob:function (url, cb) {
				var xhr = new XMLHttpRequest();
				xhr.open("GET", url);
				xhr.responseType = "blob";
				xhr.addEventListener('load', function() {
					cb(xhr.response);
				});
				xhr.send();
			},
			removeVoiceMail() {
				const storageRef = fbstore.ref().child('audio/'+this.user.id);	
				storageRef.delete().then(() => {
					db.doc(`Users/${this.user.id}`).update({'VoicemailRecord':''});
				}).catch((error) => {
					//eslint-disable-next-line
					console.log('errror',error);
				});
			},
			close(bvModalEvt) {
				if (this.isRecording && bvModalEvt.type == 'hide') {
					alert('Recording is in progress');
					bvModalEvt.preventDefault();
				}
			},
			callback (data) {
				//eslint-disable-next-line
				console.log(data)
				this.recordings.push(data);
			}
		},
		data() {
			let user = this.$store.state.firebase.user;
			return {
				recordings: [],
				uploadValue: 0,
				uploadedMediaURL:'',
				isRecording:false,
				numberMask: this.$parseNumber(user.Number),
				forwardMask: this.$parseNumber(user.ForwardNumber),
				callForwardEnabled: false,
				showFolderInput: false,
				showStageInput: false,
				showTaskInput:false,
				newFolder: "",
				newStage: "",
				newTask:"",
				form: {
					First: user.First,
					Last: user.Last,
					Email: user.Email,
					Number: user.Number,
					ForwardNumber: user.ForwardNumber,
					Folders: user.Folders ? [...user.Folders] : [],
					Stages: user.Stages ? [...user.Stages] : [],
					Tasks: user.Tasks ? [...user.Tasks] : [],
					AutoResponseMessage:user.AutoResponseMessage ? user.AutoResponseMessage:'',
					// AutoAppointment24h:user.AutoAppointment24h ? user.AutoAppointment24h:'',
					// AutoAppointment1h:user.AutoAppointment1h ? user.AutoAppointment1h:'',
					AutoResponseEnabled:user.AutoResponseEnabled?user.AutoResponseEnabled:false,
					AutoOffice:user.AutoOffice ? user.AutoOffice : false,
					ApplyText:user.ApplyText ? user.ApplyText : false,
					SendGroup:user.SendGroup ? user.SendGroup : false,
					// AutoAppointmentSetting:user.AutoAppointmentSetting ? user.AutoAppointmentSetting : false,
					AutoText:user.AutoText ? user.AutoText : false,
					ExploringText:user.ExploringText ? user.ExploringText : '',
					InProcessText:user.InProcessText ? user.InProcessText : '',
					LicensedText:user.LicensedText ? user.LicensedText : '',
					GroupMessage:user.GroupMessage ? user.GroupMessage : '',
					Title:user.Title? user.Title:'',
					Contact:user.Contact?user.Contact:'',
					Notification:user.Notification?user.Notification:false,
					PrimaryLocation:{
						StreetAddress:user.PrimaryLocation && user.PrimaryLocation.StreetAddress?user.PrimaryLocation.StreetAddress:'',
						City:user.PrimaryLocation && user.PrimaryLocation.City?user.PrimaryLocation.City:'',
						State:user.PrimaryLocation && user.PrimaryLocation.State?user.PrimaryLocation.State:'',
						ZipCode:user.PrimaryLocation && user.PrimaryLocation.ZipCode?user.PrimaryLocation.ZipCode:''
					},
					ForwardEmail:user.ForwardEmail? user.ForwardEmail : '',
					EmailSignature:user.EmailSignature? user.EmailSignature : '',
					ForwardText:user.ForwardText? user.ForwardText : '',
                    AiDescription:user.AiDescription ? user.AiDescription : ''

					// FromDate:user.FromDate,
					// ToDate:user.ToDate
				},
				varField:"",
				varValue:"",
				checked: false,
				chips:[],
			currentInput: ''
			}
			
		},
		// beforeRouteLeave(to, from, next) {
		// 	if (!this.dirty || (this.dirty && confirm("Leaving will discard unsaved changes"))) {
		// 		next();
		// 	}
		// }
	}
</script>

<style>
	.custom-coutry-dropdown.custom-select {
	/* width: 70px !important; */
	width: 100%!important;
    height: 36px;
	}
	.custom-outbox .bv-no-focus-ring input.custom-imput-box {
	width: calc((50% - 70px) - 20px);
	margin: 0px 10px 0px 10px;
	}
	.custom-outbox .bv-no-focus-ring input {
	width: calc((100% / 2) - 10px);
	margin: 10px 10px 10px 0px;
	}
	.custom-outbox .bv-no-focus-ring .dropdown {
		width: 60px;
		height: 35px;
		margin: 10px 0px 10px 0px;
	}
	.custom-outbox .bv-no-focus-ring button {
		background: transparent;
		color: #042b79;
		border: 1px solid #ced4da;
	}

	.custom-outbox .bv-no-focus-ring ul.dropdown-menu.show {
		width: 40px !important;
		min-width: 60px;
		min-height: 100px !IMPORTANT;
		height: 200px;
		overflow: auto;
	}
	

	.custom-outbox .bv-no-focus-ring ul.dropdown-menu.show li {
		width: 100%;
		display: inline-block;
	}

	.custom-outbox .bv-no-focus-ring ul.dropdown-menu.show li a.dropdown-item {
		width: 100% !important;
		display: inline-block;
		padding: 2px 9px;
		text-align: center;
	}
	.custom-outbox .bv-no-focus-ring .dropdown button{
		width:100%;height:100%;
	}
	.custom-outbox .bv-no-focus-ring{
		display:flex;flex-wrap: wrap;
	}
	.custom-outbox .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus{
			box-shadow: none  !important;
	}
	#Settings {
		text-align: left;
	}
	.button-text {
		display: inline-block;
		vertical-align: middle;
		padding: 0.375rem 0rem;
	}
	.no-glow:focus {
		border-color: transparent;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0) inset, 0px 0px 0px rgba(255, 100, 255, 0);
	}
	.variable-wrapper input{
		margin-right: 10px;
	}
	
	
	.automation .custom-switch .custom-control-label:before {
		left: 106% !important;
		width: 1.75rem;
	}
	.automation .custom-switch .custom-control-label::after {
		left: calc(106% + 2px) !important;}
		.automation .custom-switch {
		padding-right: 2.25rem !important;
		padding-left: 0 !important;
	}
	.automation .custom-control.custom-switch label.custom-control-label {
		padding-right: 10px;
		width: 100%;
		display: inline-block;
		flex: 0 0 16.666667%;
		max-width: 16.666667%;
	} 


.chip-container {
	width: 400px;
	border: 1px solid #ccc;
	min-height: 34px;
	display:flex;
	flex-wrap: wrap;
	align-content: space-between;
}
.custom-tag1 span{
	float: left;
}
.chip-container .chip {
    margin:4px;
    background: #e0e0e0;
    padding:0px 4px;
    border: 1px solid #ccc;
    border-radius:3px;
    display:flex;
    align-items: center;
}
.chip-container .chip i {
	cursor: pointer;
	opacity: .56;
	margin-left:8px;
}

.chip-container input {
    flex: 1 1 auto;
    width:30px;
    border: none;
    outline: none;
    padding:4px;
} 
  .automation-inputbox div.custom-tag {
    padding-right: 10px;
}
.automation-inputbox div.custom-tag1 span {
    padding: 5px;
    background: #ced4da;
    border: 1px solid #ccc;
    margin-right: 8px;
    border-radius: 4px;float: left;
}
.automation-inputbox div.custom-tag:focus {
    outline: none;
}
.automation-inputbox div.custom-tag1 {
border: 1px solid #ced4da;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding: 10px;
}
#VoiceMailModal___BV_modal_body_ .ar-icon__sm{
display: flex;
}
#VoiceMailModal___BV_modal_body_ .ar-icon__lg{
display:flex;
}
#VoiceMailModal___BV_modal_body_ .ar-icon{
border:1px solid #042B79;
}
#VoiceMailModal___BV_modal_body_ .ar-player__play--active{
	background-color: #042B79 !important;
}
#VoiceMailModal___BV_modal_body_ .ar {
    width: 100%;box-shadow: none;}
  /* <div class="chip-container">
      <div class="chip" v-for="(chip, i) of chips" :key="chip.label">
        {{chip}}
        
      </div>
      <input v-model="currentInput" @keypress.enter="saveChip" @keydown.delete="backspaceDelete">
    </div>
  */
.recorded-item {
    display: flex;
    align-items: center;
    justify-content: center;
}

.recorded-item .audio-container {
    margin-right: 5px;
}

.column {
    padding-top: 15px;
}

.recorded-item div:nth-child(2) button.button.is-dark {
    background: #ef5350;
    border: none;
    outline: none;
    border-radius: 100%;
    padding: 3px 5px;
    color: #fff;
    display: flex;
    width: 35px;
    align-items: center;
    font-size: 13px;
    height: 35px;
    /* border-radius: 100%; */
    align-items: center;
    justify-content: center;
}
.recorded-item div:nth-child(2) button.button.is-dark svg.fa-icon {
    width: 13px;
}

div#VoiceMailModal___BV_modal_body_ {
    text-align: center;
}

.vue-audio-recorder:hover {
    background-color: rgb(2 22 61 / 80%) !important;
}

.call-bottom {
    width: 100%;
    text-align: end;
}

.call-bottom button {
    width: 85px;outline: none;
    margin-top: 20px;
    /* color: #02163d; */
    background: #02163d !important;
}
.vue-audio-recorder.active {
    background-color: #ef5350 !important;}
.vue-audio-recorder{
	background-color: #02163d !important;
}
button.button.is-dark.custom-stop-btn {
    position: absolute;
    margin-left: 14px;
    border-radius: 100%;
    top: 27px;
    width: 45px;
    background: transparent;
    border: 1px solid #02163d;
    height: 45px;outline: none;
    /* display: flex; */
    align-items: center;
    justify-content: center;
}
button.button.is-dark.custom-stop-btn svg.fa-icon{
    margin-top: -4px;
}
.setrow .bv-no-focus-ring {
    display: flex;
    align-items: center;
}
.button.is-dark {
    border: 1px solid transparent;
    background: red;
    color: white;
    border-radius: 100px;
    padding: 5px 10px;
    margin-left: 5px;
}
.settingDiv{
	padding: 0px 20px 20px 20px!important;
}
.settingDiv h3{
	font-size: 20px;
    margin: 15px 20px 15px 15px;
}
.settingDiv .showNumberEmail{
	padding: 14px;
}
.ResourcesTab{
	font-size: 12px!important;
	margin: 12px 0px!important;
}
.stagesTagUI{
	margin: 2px;
}
.stagesTagUIClose{
	padding: 0px 8px 0px 3px!important;
}
</style>
